(function () {
 const TARGET_SELECTORS = {
 'rich-text': '.rich-text',
 'multicolumn': '.multicolumn',
 'collection-list': '.collection-list-wrapper',
 'featured-collection': '.collection[id^="collection-"]',
 'image-with-text': '.image-with-text',
 'tr-email-signup': '.tr-email-signup',
 'image-banner': '.banner:not(.slideshow):not(.email-signup-banner)',
 'product-information': 'product-info, .main-product, .featured-product',
 'footer': 'footer.footer'
 };
 const BANNER_MODE_CLASSES = ['tr-layout-image-banner--content', 'tr-layout-image-banner--full'];
 const HEIGHT_MODE_CLASSES = [
   'tr-layout-height-desktop--fixed',
   'tr-layout-height-desktop--viewport',
   'tr-layout-height-mobile--fixed',
   'tr-layout-height-mobile--viewport'
 ];




 function getWrapper(el) {
   return el.closest('[id^="shopify-section-"]');
 }


 function getNextShopifySection(wrapper) {
   let el = wrapper.nextElementSibling;
   while (el && (!el.id || !el.id.startsWith('shopify-section-'))) {
     el = el.nextElementSibling;
   }
   return el;
 }

 function findNextMatchingSection(wrapper, selector) {
   let section = getNextShopifySection(wrapper);
   while (section) {
     if (section.querySelector(selector)) return section;
     section = getNextShopifySection(section);
   }
   return null;
 }


 function applyVars(triggerEl, targetSectionEl) {
   const styles = getComputedStyle(triggerEl);
   ['--tr-maxw', '--tr-maxw-m', '--tr-gx', '--tr-gy', '--tr-pad-top', '--tr-pad-bottom', '--tr-min-h', '--tr-h', '--tr-h-vh', '--tr-h-mobile', '--tr-h-mobile-vh', '--tr-gap', '--tr-gap-m'].forEach((v) => {
     const val = styles.getPropertyValue(v).trim();
     if (val) targetSectionEl.style.setProperty(v, val);
   });
 }


 function applyImageBannerMode(triggerEl, targetSectionEl, targetType) {
   BANNER_MODE_CLASSES.forEach((cls) => targetSectionEl.classList.remove(cls));
   if (targetType !== 'image-banner') return;

   const mode = (triggerEl.dataset.bannerWidthMode || 'content').trim() === 'full' ? 'full' : 'content';
   targetSectionEl.classList.add(`tr-layout-image-banner--${mode}`);
 }


 function applyHeightMode(triggerEl, targetSectionEl) {
   HEIGHT_MODE_CLASSES.forEach((cls) => targetSectionEl.classList.remove(cls));
   const desktopModeRaw = (triggerEl.dataset.heightMode || 'none').trim();
   const desktopMode = desktopModeRaw === 'min' ? 'fixed' : desktopModeRaw;
   const mobileMode = (triggerEl.dataset.mobileHeightMode || 'match-desktop').trim();

   if (desktopMode === 'fixed') {
     targetSectionEl.classList.add('tr-layout-height-desktop--fixed');
   } else if (desktopMode === 'viewport') {
     targetSectionEl.classList.add('tr-layout-height-desktop--viewport');
   }
   if (mobileMode === 'fixed' || (mobileMode === 'match-desktop' && desktopMode === 'fixed')) {
     targetSectionEl.classList.add('tr-layout-height-mobile--fixed');
   } else if (mobileMode === 'viewport' || (mobileMode === 'match-desktop' && desktopMode === 'viewport')) {
     targetSectionEl.classList.add('tr-layout-height-mobile--viewport');
   }
 }

 function applyTrigger(triggerEl) {
   const wrapper = getWrapper(triggerEl);
   if (!wrapper) return;


   const expectedType = (triggerEl.dataset.target || '').trim();
   const nextSection = getNextShopifySection(wrapper);
   if (!nextSection) return;


   if (expectedType) {
     const sel = TARGET_SELECTORS[expectedType];
     if (!sel) return;


     const targetSection = nextSection.querySelector(sel) ? nextSection : findNextMatchingSection(nextSection, sel);
     if (!targetSection) return;


     targetSection.classList.add('tr-layout-target', `tr-layout-target--${expectedType}`);
     applyVars(triggerEl, targetSection);
     applyImageBannerMode(triggerEl, targetSection, expectedType);
     applyHeightMode(triggerEl, targetSection);
     return;
   }


   // Optional inference (only used if no dropdown target set)
   for (const [type, sel] of Object.entries(TARGET_SELECTORS)) {
     if (nextSection.querySelector(sel)) {
       nextSection.classList.add('tr-layout-target', `tr-layout-target--${type}`);
       applyVars(triggerEl, nextSection);
       applyImageBannerMode(triggerEl, nextSection, type);
       applyHeightMode(triggerEl, nextSection);
       break;
     }
   }
 }


 function init() {
   document.querySelectorAll('[data-tr-layout-trigger]').forEach(applyTrigger);
 }


 document.addEventListener('DOMContentLoaded', init);
 document.addEventListener('shopify:section:load', init);
})();
